import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { whatsappLink, contactInfo } from '../mock';

const FloatingButtons = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* WhatsApp Button */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center justify-center w-16 h-16 bg-green-500 text-white rounded-full shadow-2xl hover:bg-green-600 transition-all transform hover:scale-110 animate-bounce"
        title="WhatsApp ile İletişim"
      >
        <MessageCircle className="w-8 h-8" />
        <span className="absolute right-20 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          WhatsApp
        </span>
      </a>

      {/* Phone Call Button */}
      <a
        href="tel:05534834264"
        className="group relative flex items-center justify-center w-16 h-16 bg-orange-600 text-white rounded-full shadow-2xl hover:bg-orange-700 transition-all transform hover:scale-110"
        title="Hemen Ara"
      >
        <Phone className="w-8 h-8" />
        <span className="absolute right-20 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Hemen Ara
        </span>
      </a>
    </div>
  );
};

export default FloatingButtons;